<div fxLayout="column" fxLayoutAlign="space-between start">
    <div *ngIf="!hideLabel" class="forge-typography--heading1">{{label}}</div>

    <div [fxLayout]="layout" role="radiogroup" [attr.aria-label]="groupLabel">
        <ng-container *ngFor="let option of options">
            <forge-radio [value]="option" [formControl]="formControl" [name]="controlName" [id]="getOptionId(option)">
                <span slot="helper-text" *ngIf="hasError('required')">
                    {{label}} is required
                </span>
                <forge-tooltip>{{tooltip}}</forge-tooltip>
                {{ getDisplayValue(option) }}
            </forge-radio>
        </ng-container>
    </div>
</div>